module.exports = __webpack_public_path__ + "static/media/wakeforest.2ac9c96d.png";